import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import Select, { components } from "react-select";

import { durationCustomStyles, DropdownIndicator } from "app/components/PaymentSelector";
import { PaymentStatusOptions } from "./paymentHelpers";
import styles from "./styles.module.scss";

interface PaymentStatusSelectProps {
  paymentEditable: boolean;
  watchPaymentMethod: string;
}

const PaymentStatusSingleValue = ({ data, ...props }: any) => (
  <components.SingleValue {...props} data={data}>
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <span
        className={styles.payment_status_dot}
        style={{ backgroundColor: data.color }}
      />
      {data.label}
    </div>
  </components.SingleValue>
);

const PaymentStatusOption = ({ data, innerRef, innerProps, isSelected }: any) => (
  <div
    ref={innerRef}
    {...innerProps}
    style={{
      padding: '10px 12px',
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      backgroundColor: isSelected ? '#f0f0f0' : 'white',
    }}
  >
    <span
      className={styles.payment_status_dot}
      style={{ backgroundColor: data.color }}
    />
    {data.label}
  </div>
);

export default function PaymentStatusSelect({ paymentEditable, watchPaymentMethod }: PaymentStatusSelectProps) {
  const { control } = useFormContext();

  return (
    <Controller
      name="payment_status"
      control={control}
      render={({ field }) => (
        <Select
          {...field}
          options={PaymentStatusOptions.filter(o => o.value !== 'failed' && o.value !== 'past_due')}
          value={PaymentStatusOptions.find(o => o.value === field.value) || PaymentStatusOptions[0]}
          onChange={(option: any) => field.onChange(option.value)}
          isDisabled={!paymentEditable || watchPaymentMethod === 'online'}
          styles={durationCustomStyles}
          isSearchable={false}
          menuPortalTarget={document.body}
          menuPlacement="auto"
          classNamePrefix="rs"
          components={{
            IndicatorSeparator: () => null,
            DropdownIndicator,
            SingleValue: PaymentStatusSingleValue,
            Option: PaymentStatusOption,
          }}
        />
      )}
    />
  );
}
